import { useIsAdminMode } from "@/contexts";
import { Cart } from "@/interfaces";
import { CartHelper } from "@/helpers";
import ProductCartSubtotals from "../ProductCartSubtotals";
import ProductCartDiscount from "../ProductCartDiscount";
import { Coupons, Shipping, ShippingFee } from "../../atoms";
import * as S from "./styles";

export type ProductCartSubtotalsAndShippingProps = {
  cart?: Cart;
  couponAmountDisabled?: boolean;
  onAddShippingClick?: () => void;
  onDiscountChange?: (value: number) => void;
  onCouponAmountChange?: (value?: number) => void;
  onCouponQuantityChange?: (value?: number) => void;
};

const ProductCartSubtotalsAndShipping: React.FC<
  ProductCartSubtotalsAndShippingProps
> = ({
  cart = undefined,
  couponAmountDisabled = undefined,
  onAddShippingClick = undefined,
  onDiscountChange = undefined,
  onCouponAmountChange = undefined,
  onCouponQuantityChange = undefined,
}) => {
  const { isAdminMode } = useIsAdminMode();

  return cart ? (
    <S.ProductCartSubtotalsAndShippingContainer>
      <S.ProductCartSubtotalsAndShipping>
        <ProductCartSubtotals cart={cart} />
        {isAdminMode ? (
          <ProductCartDiscount
            value={cart.discount}
            onChange={onDiscountChange}
          />
        ) : null}
        <Shipping
          onAddShippingClick={onAddShippingClick}
          shippingFee={cart?.shippingFee}
        />
        <ShippingFee shippingFee={CartHelper.getShippingFee(cart)} />
        <Coupons
          amount={cart.couponAmount}
          quantity={cart.couponQuantity}
          amountDisabled={couponAmountDisabled}
          onAmountChange={onCouponAmountChange}
          onQuantityChange={onCouponQuantityChange}
        />
      </S.ProductCartSubtotalsAndShipping>
    </S.ProductCartSubtotalsAndShippingContainer>
  ) : null;
};

export default ProductCartSubtotalsAndShipping;
